<template>
  <template
    v-for="experience in consideredExperiences"
    :key="experience.sys.id"
  >
    <LibErrorBoundary component-name="Experience" :child-props="experience">
      <Experience
        :item="experience"
        :display-baseline-content="
          item.fields.includeBaselineContentOfRelatedExperiences
        "
      />
    </LibErrorBoundary>
  </template>
  <MappedComponents
    v-if="!firstMatchingExperience"
    :items="item.fields.baselineContent ?? []"
  />
</template>

<script setup lang="ts">
import type { IExperience, IMultiExperience } from '~/lib/ContentfulService';
import { isDefined } from '~/utils/guards/isDefined';
import Experience from '~/components/contentful/Experience.vue';

interface Props {
  item: IMultiExperience;
}

const props = defineProps<Props>();

const { $matchingAudiences } = useNuxtApp();
const firstMatchingExperience: ComputedRef<IExperience | undefined | null> =
  computed(() => {
    for (const experience of props.item.fields.experiences) {
      for (const id of experience.fields.audiences?.map(
        (audience) => audience.sys.id
      ) ?? []) {
        if ($matchingAudiences.value.includes(id)) {
          return experience;
        }
      }
    }
  });

const consideredExperiences: ComputedRef<IExperience[]> = computed(() => {
  if (props.item.fields.stopsAfterHit) {
    return isDefined(firstMatchingExperience.value)
      ? [firstMatchingExperience.value]
      : [];
  }
  return props.item.fields.experiences;
});
</script>
